import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getFences } from '../../services/fenceService';
import {
  fencesPageState,
  fencesState,
  loadingFencesState,
  searchFenceState,
  selectedFenceIdState,
  updateFencesState,
} from '../../storage/fences';
import { Fence } from '../../types/fence';
import { PaginatedProvider } from './PaginatedProvider';

export function FencesProvider() {
  const setLoadingFences = useSetRecoilState(loadingFencesState);
  const setPaginatedFences = useSetRecoilState(fencesState);
  const updateFences = useRecoilValue(updateFencesState);
  const resetUpdateFences = useResetRecoilState(updateFencesState);
  const resetSelectedFenceId = useResetRecoilState(selectedFenceIdState);

  return (
    <PaginatedProvider<Fence>
      searchState={searchFenceState}
      pageState={fencesPageState}
      getPaginated={getFences}
      setPaginated={setPaginatedFences}
      onSearchChange={resetSelectedFenceId}
      onUpdateFinish={() => {
        resetUpdateFences();
      }}
      setLoading={setLoadingFences}
      update={updateFences}
    />
  );
}
